import { TPermissionItem } from "@/data/types";

export interface PermissionsState {
  items: TPermissionItem[];
  currentPermission: TPermissionItem | null;
}

export const DefaultPermissionsState: PermissionsState = {
  items: [],
  currentPermission: null,
};